import dayjs from 'dayjs'
import { getPercentage } from 'src/consumer/helpers/utilFunctions'
import { ReportsSubTableContainer, ReportsTableItem } from '../../styledComponents'
import {
  getValidIntegerOrNaForClinicReport,
  getValidPercentageOrNaForClinicReport,
} from '../OverallReportComponent'

function renderSubItemIntegerDiv(value, isPercentage = false) {
  if (isPercentage) {
    return <div className="report-sub-item">{getValidPercentageOrNaForClinicReport(value)}</div>
  }

  return <div className="report-sub-item">{getValidIntegerOrNaForClinicReport(value)}</div>
}

export default function ScreenerBreakUpReportTableData({
  metricData,
  reportEndTime,
  reportStartTime,
  getCorrectReportDateString,
  columns,
  screeners,
  fullReport,
  metricString,
}) {
  const screenerMetrics = screeners?.reduce((acc, screener) => {
    const metrics = fullReport?.metrics
    const metricKey = `${metricString}__${screener?.id}`
    acc[screener?.id] = metrics?.[metricKey] || {}
    return acc
  }, {})

  return (
    <ReportsTableItem columns={columns}>
      <div className="reports-top-header">
        {reportEndTime &&
          getCorrectReportDateString(
            dayjs.utc(reportEndTime).local(),
            dayjs.utc(reportStartTime).local(),
          )}
      </div>
      {/* sub header */}
      <ReportsSubTableContainer className="report-item px-0" columns={3}>
        <div className="fw-bold break-word-class report-sub-item">Booked</div>
        <div className="fw-bold break-word-class report-sub-item">Conducted</div>
        <div className="fw-bold break-word-class report-sub-item">% Conducted</div>
      </ReportsSubTableContainer>

      {/* total booking data */}
      <ReportsSubTableContainer className="report-item px-0" columns={3}>
        {renderSubItemIntegerDiv(metricData?.totalBookedCount)}
        {renderSubItemIntegerDiv(metricData?.totalConductedCount)}
        {renderSubItemIntegerDiv(
          getPercentage(metricData?.totalConductedCount, metricData?.totalBookedCount, 0),
          true,
        )}
      </ReportsSubTableContainer>

      {/* total booking data for screeners */}
      {screeners?.map((screener, idx) => (
        <ReportsSubTableContainer className="report-item px-0" key={screener?.id} columns={3}>
          {renderSubItemIntegerDiv(screenerMetrics?.[screener?.id]?.totalBookedCount)}
          {renderSubItemIntegerDiv(screenerMetrics?.[screener?.id]?.totalConductedCount)}
          {renderSubItemIntegerDiv(
            getPercentage(
              screenerMetrics?.[screener?.id]?.totalConductedCount,
              screenerMetrics?.[screener?.id]?.totalBookedCount,
              0,
            ),
            true,
          )}
        </ReportsSubTableContainer>
      ))}

      {/* new booking data */}
      <ReportsSubTableContainer className="report-item px-0" columns={3}>
        {renderSubItemIntegerDiv(metricData?.newBookedCount)}
        {renderSubItemIntegerDiv(metricData?.newConductedCount)}
        {renderSubItemIntegerDiv(
          getPercentage(metricData?.newConductedCount, metricData?.newBookedCount, 0),
          true,
        )}
      </ReportsSubTableContainer>

      {/* new booking data for screeners */}
      {screeners?.map((screener, idx) => (
        <ReportsSubTableContainer className="report-item px-0" key={screener?.id} columns={3}>
          {renderSubItemIntegerDiv(screenerMetrics?.[screener?.id]?.newBookedCount)}
          {renderSubItemIntegerDiv(screenerMetrics?.[screener?.id]?.newConductedCount)}
          {renderSubItemIntegerDiv(
            getPercentage(
              screenerMetrics?.[screener?.id]?.newConductedCount,
              screenerMetrics?.[screener?.id]?.newBookedCount,
              0,
            ),
            true,
          )}
        </ReportsSubTableContainer>
      ))}

      {/* existing booking data */}
      <ReportsSubTableContainer className="report-item px-0" columns={3}>
        {renderSubItemIntegerDiv(metricData?.repeatBookedCount)}
        {renderSubItemIntegerDiv(metricData?.repeatConductedCount)}
        {renderSubItemIntegerDiv(
          getPercentage(metricData?.repeatConductedCount, metricData?.repeatBookedCount, 0),
          true,
        )}
      </ReportsSubTableContainer>

      {/* existing booking data for screeners */}
      {screeners?.map((screener, idx) => (
        <ReportsSubTableContainer className="report-item px-0" key={screener?.id} columns={3}>
          {renderSubItemIntegerDiv(screenerMetrics?.[screener?.id]?.repeatBookedCount)}
          {renderSubItemIntegerDiv(screenerMetrics?.[screener?.id]?.repeatConductedCount)}
          {renderSubItemIntegerDiv(
            getPercentage(
              screenerMetrics?.[screener?.id]?.repeatConductedCount,
              screenerMetrics?.[screener?.id]?.repeatBookedCount,
              0,
            ),
            true,
          )}
        </ReportsSubTableContainer>
      ))}
    </ReportsTableItem>
  )
}
